<template>
  <div class="tab_content tab__more_information">
    <div class="more_information__note vx-row items-center mx-2">
      <h3 class="mr-2">More Information</h3>
    </div>

    <!-- form - more information -->
    <div class="vx-row px-5 pt-5">
      <!-- col - 1 -->
      <div class="vx-col w-full">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <!-- room type Dropdown -->
          <div v-if="showAll">
            <label>Room Type</label>
            <select-2
              autocomplete
              class="w-full"
              :value="form.room_type"
              @input="
                (item) => {
                  form.room_type = item && item.value
                }
              "
              name="Room Type"
              placeholder="Select Room Type"
              :options="roomTypes"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Room Type')">{{ errors.first('Room Type') }}</span> -->
          </div>

          <!-- plant stage Dropdown -->
          <div v-if="showAll">
            <label>Plant Stage </label>
            <select-2
              autocomplete
              class="w-full"
              :value="form.plant_stage"
              @input="
                (item) => {
                  form.plant_stage = item && item.value
                }
              "
              name="Plant Stage"
              placeholder="Select Plant Stage"
              :options="plantStages"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Plant Stage')">{{ errors.first('Plant Stage') }}</span> -->
          </div>

          <!-- grow method -->
          <div v-if="showAll">
            <label for="">Grow Method</label>
            <select-2
              autocomplete
              class="w-full"
              name="Grow Method"
              :value="form.grow_method"
              @input="
                (item) => {
                  form.grow_method = item && item.value
                }
              "
              placeholder="Select Grow Method"
              :options="growMethods"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Grow Method')">{{ errors.first('Grow Method') }}</span> -->
          </div>

          <!-- Pur. price -->
          <div>
            <vs-input
              type="number"
              step="0.01"
              v-model="form.purchase_price"
              @change="calculatePerchasePrice"
              icon="icon icon-list"
              icon-pack="feather"
              class="w-full"
              label="Pur. Price"
              name="purPrice"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('purPrice')">{{ errors.first('purPrice') }}</span> -->
          </div>

          <!-- CBD % -->
          <div v-if="showAll">
            <vs-input type="number" step="0.01" v-model="form.cbd" @change="form.cbd = mathRound(form.cbd || 0, 2)" icon="icon icon-list" icon-pack="feather" class="w-full" label="CBD %" name="cbd" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('cbd')">{{ errors.first('cbd') }}</span> -->
          </div>

          <!-- Alert qty -->
          <div>
            <vs-input
              step="0.01"
              v-model="form.alert_quantity"
              @change="form.cbd = mathRound(form.cbd || 0, 0)"
              type="number"
              icon="icon icon-list"
              icon-pack="feather"
              class="w-full"
              label="Alert Qty"
              name="Alert Qty"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Alert Qty')">{{ errors.first('Alert Qty') }}</span> -->
          </div>

          <!-- Profit Margin -->
          <div v-if="showAll">
            <vs-input
              type="number"
              step="0.01"
              v-model="form.profit_margin"
              @change="calculateProfiteMargin"
              icon="icon icon-list"
              icon-pack="feather"
              class="w-full"
              label="Profit Margin (%)"
              name="Profit Margin"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Profit Margin')">{{ errors.first('Profit Margin') }}</span> -->
          </div>

          <!-- terpenoid potency -->
          <div v-if="showAll">
            <vs-input
              type="number"
              step="0.01"
              v-model="form.terpenoid_potency"
              @change="form.terpenoid_potency = mathRound(form.terpenoid_potency || 0, 2)"
              icon="icon icon-list"
              icon-pack="feather"
              class="w-full"
              label="Terpenoid Potency (%)"
              name="Terpenoid Potency"
            />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Terpenoid Potency')">{{ errors.first('Terpenoid Potency') }}</span> -->
          </div>

          <!-- thc % -->
          <div v-if="showAll">
            <vs-input type="number" step="0.01" v-model="form.thc" @change="form.thc = mathRound(form.thc || 0, 2)" icon="icon icon-list" icon-pack="feather" class="w-full" label="THC %" name="THC" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('THC')">{{ errors.first('THC') }}</span> -->
          </div>

          <!-- waste in pound -->
          <div>
            <vs-input
              type="number"
              step="0.001"
              v-model="form.waste_in_pounds"
              @change="form.waste_in_pounds = mathRound(form.waste_in_pounds || 0, 3)"
              icon="icon icon-list"
              icon-pack="feather"
              class="w-full"
              label="Waste in pound"
              name="Waste"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { growMethods, roomTypes, plantStages } from '@/utils/batch-options'
import { weightMixins } from '@/utils/weightType'

export default {
  name: 'MoreInformationTab',
  components: {
    Select2
  },
  props: {
    form: {
      type: Object
    },
    showAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      console,
      growMethods,
      roomTypes,
      plantStages
    }
  },
  mixins: [weightMixins],
  methods: {
    calculatePerchasePrice() {
      const t = { purchase_price: this.mathRound(this.form.purchase_price || 0, 2) }
      if (t.purchase_price > 0 && t.purchase_price <= this.form.sales_price) {
        t.sales_price = this.form.sales_price || t.purchase_price
        t.profit_margin = this.mathRound(((t.sales_price - t.purchase_price) / t.purchase_price) * 100, 2)
      } else if (t.purchase_price > this.form.sales_price) {
        t.sales_price = t.purchase_price
        t.profit_margin = 0
      } else {
        t.profit_margin = 0
      }
      this.$emit('update:form', {
        ...this.form,
        ...t
      })
    },
    calculateProfiteMargin() {
      const t = { profit_margin: this.mathRound(this.form.profit_margin || 0, 2) }
      if (t.profit_margin > 0 && this.form.purchase_price > 0) {
        t.sales_price = this.mathRound(((100 + t.profit_margin) * this.form.purchase_price) / 100, 2)
      } else {
        t.profit_margin = 0
        t.sales_price = 0
        t.profit_margin = 0
      }
      this.$emit('update:form', {
        ...this.form,
        ...t
      })
    }
  },

  computed: {
    ...mapState('product', ['loading', 'categories']),

    isPlantStageRequired() {
      return [this.categories.PLANT, this.categories.MATURE].includes(this.form.categoryId)
    }
  }
}
</script>
